.winner-badge {
    padding: 2px 8px;
    border-radius: 3px;
    background-color: var(--green);
    color: var(--white);
    display: inline-flex;
    align-items: center;
}
